import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SelectionItem } from '../../../core/component/select/select.component';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { Dwelling } from '../../model/dwelling';
import { Parking } from '../../model/parking';
import { Premises } from '../../model/premises';
import { RentalObjectKey } from '../../model/rental-object-key';
import { KeyTypeService } from '../../service/data/key-type.service';
import { BrfInnerFundTransaction } from '../../model/brf-inner-fund-transaction';
import { LocalDate } from '../../../core/model/local-date';
import { Money } from '../../../core/model/money';

@Component({
    selector: 'app-rental-object-fund-transactions',
    templateUrl: './rental-object-fund-transactions.component.html',
    styleUrls: ['./rental-object-fund-transactions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RentalObjectFundTransactionsComponent implements OnInit, OnDestroy {
  constructor(private _fb: FormBuilder, private _cf: FormControlExFactory) {}

  private _forms: FormArray;
  @Input() set forms(value: AbstractControl) {
    this._forms = value as FormArray;
  }
  get forms(): FormArray {
    return this._forms;
  }
  @Input() fundTransaction: BrfInnerFundTransaction[];
  @Input() rentalObject: Dwelling;
  private _subscription = new Subscription();

  addTransaction() {
    this.forms.controls.push(
      this.createForm(
        new BrfInnerFundTransaction({
          amount: new Money(this.rentalObject.currencyCode, 0),
          transactionDate: LocalDate.today(),
          rentalObjectId: this.rentalObject.id,
          description: null,
        })
      )
    );

    this.forms.markAsDirty();
  }

  delete(fundTransaction: FormGroup) {
    this.forms.controls.splice(this.forms.controls.indexOf(fundTransaction), 1);
    this.forms.markAsDirty();
  }

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  initForm() {    
    let fundTransactions = this.rentalObject ? this.rentalObject.brfInnerFundTransactions : this.fundTransaction;
    for (let fundTransaction of fundTransactions.sort(
      (a, b) =>
        new Date(a.transactionDate.year, a.transactionDate.month, a.transactionDate.day).getTime() -
        new Date(b.transactionDate.year, b.transactionDate.month, b.transactionDate.day).getTime()
    )) {
      let group = this.createForm(fundTransaction);
      this.forms.controls.push(group);
    }
  }

  private createForm(transaction: BrfInnerFundTransaction): FormGroup {
    let group = this._fb.group({
      id: this._cf.createHidden(transaction.id),
      rentalObjectId: this._cf.createHidden(transaction.rentalObjectId),
      amount: this._cf.createMandatory('COOPERATIVE_HOUSING.INNER_FUND_TRANSACTION_AMOUNT', transaction.amount),
      transactionDate: this._cf.createMandatory('COOPERATIVE_HOUSING.INNER_FUND_TRANSACTION_DATE', transaction.transactionDate),
      description: this._cf.create('COMMON.DESCRIPTION', transaction.description),
    });

    this._subscription.add(group.controls['amount'].valueChanges.subscribe(val => this.forms.markAsDirty()));
    this._subscription.add(
      group.controls['transactionDate'].valueChanges.subscribe(val => {
        this.forms.markAsDirty();
      })
    );
    this._subscription.add(
      group.controls['description'].valueChanges.subscribe(val => {
        this.forms.markAsDirty();
      })
    );
    return group;
  }
  ngOnInit(): void {
    this.initForm();
  }
}
